appConfig.getModule()
    .run(['$rootScope', '$state', '$urlRouter', '$templateCache', 'AUTH_EVENTS', 'authService',
        function ($rootScope, $state, $urlRouter, $templateCache, AUTH_EVENTS, authService) {
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                // stop all transition before request is authenticated
                event.preventDefault();

                // modified it on 7Mar now auth will check on publish mode as well
                if(_DASHBOARD_MODE == "publish_no_use") { // when dashboard is in published mode do not authenticate user
                    $state.go(toState.name, toParams, {
                        notify: false
                    }).then(function () {
                        $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                    });
                } 
                else {
                    authService.isAuthenticated()
                        .then(function (isAuthenticated) { 
                            //console.log(isAuthenticated);console.log(toState);console.log(authService.isAuthorized());console.log(appConfig.appName);
                            var isAuthorized = authService.isAuthorized2(toState.name);
                            
                            if (toState.name == appConfig.appName && isAuthenticated && !publishDashboardId && isAuthorized) {
                                $state.go('dfaBYD.home.dashboardMgt');
                            } else { 
                                if (toState.data.authenticationRequired) {
                                    if (isAuthenticated && isAuthorized) {
                                        $state.go(toState.name, toParams, {
                                            notify: false
                                        }).then(function () {
                                            $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                                        });
                                    } else {
                                        $state.go('dfaBYD.notAuthorized');
                                        //location.href = _WEBSITE_URL;    
                                    }
                                } else {
                                    $state.go(toState.name, toParams, {
                                        notify: false
                                    }).then(function () {
                                        $rootScope.$broadcast('$stateChangeSuccess', toState, toParams, fromState, fromParams);
                                    });
                                }
                            }
                        })
                }
            });
        }
    ])

    .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', '$controllerProvider', '$filterProvider', '$compileProvider', '$provide', '$injector', '$locationProvider', 'localStorageServiceProvider', 'cfpLoadingBarProvider', 'MODULES', 'ACTIONS',
        function ($stateProvider, $urlRouterProvider, $httpProvider, $controllerProvider, $filterProvider, $compileProvider, $provide, $injector, $locationProvider, localStorageServiceProvider, cfpLoadingBarProvider, MODULES, ACTIONS) {

            var agGridLscKey = "Community_Solutions_Foundation_CSF_Devs_13_October_2018__MTUzOTM4NTIwMDAwMA==500b28c724d110b0af8aa885bf13c66a"
            //registerers for dynamic modules.
            appConfig.registerCtrl = $controllerProvider.register;
            appConfig.registerFactory = $provide.factory;
            appConfig.registerService = $provide.service;
            appConfig.registerDirective = $compileProvider.directive;
            appConfig.registerFilter = $filterProvider.register;

            appConfig.providers = {
                $controllerProvider: $controllerProvider,
                $compileProvider: $compileProvider,
                $filterProvider: $filterProvider,
                $provide: $provide
            };
            appConfig.$injector = $injector;

            // $locationProvider.html5Mode(!!publishDashboardId);

            localStorageServiceProvider
                .setPrefix(appConfig.appName);

            $httpProvider.interceptors.push('authInterceptor');

            // cfpLoadingBarProvider.spinnerTemplate = '<div class="load-page"><div class="loader-text fade-in fast"><div class="loader lt-ie9"></div><p>' + 'Loading...' + '</p></div></div>';

            // cfpLoadingBarProvider.includeBar = false;

            $urlRouterProvider.otherwise('/');

            $stateProvider
                .state(registerState('areaprofile'), {
                    url: 'AreaProfile',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: function () {
                                if (publishDashboardId != undefined) {
                                    return 'js/app/components/profileHome/views/index.html';
                                }
                                return 'js/app/components/core/views/login.html'
                            },
                            controllerProvider: function () {
                                if (publishDashboardId != undefined) {
                                    return 'profileHomeCtrl'
                                }
                                return;
                            }
                        }
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            
                            requirejs(['agGrid','d3'], function (agGrid) {
                                agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                agGrid.initialiseAgGridWithAngular1(angular);
                                requirejs(['profileHomeModule'], function () {
                                    deferred.resolve('');
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })                 

                .state(registerState(), {
                    url: '/?showHeader&showFooter&section&areaId&timePeriod&sectionId&lang&?anchorId',
                    views: {
                        'header': {},
                        'content': {
                            templateUrl: function () {
                                if (publishDashboardId != undefined) {
                                    return 'js/app/components/preview/views/index.html';
                                }
                                return 'js/app/components/core/views/login.html'
                            },
                            controllerProvider: function () {
                                if (publishDashboardId != undefined) {
                                    return 'previewCtrl'
                                }
                                return;
                            }
                        },
                        'footer': {
                            templateUrl: function () {
                                if (publishDashboardId != undefined) {
                                    return;
                                }
                                return 'js/app/components/core/views/footer.html';
                            }
                        }
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        languageOptions: ['$q', '$timeout', '$rootScope', 'translationsService', function ($q, $timeout, $rootScope, translationsService) {

                            var deferred = $q.defer();

                            translationsService.getLanguageList({
                                defaultLang: false
                            }).then(function (data) {
                                $rootScope.languageOptions = data.languagesList;

                                // var userSelectedLanguage = translationsService.getUserSelectedLanguage('previewTranslation');
                                var userSelectedLanguage = translationsService.getUserSelectedLanguage('translation');

                                // set userselected Language to rootscope.
                                if (userSelectedLanguage != '') {
                                    $rootScope.selectedLangCode = userSelectedLanguage;
                                    angular.forEach($rootScope.languageOptions, function (lang) {
                                        if (lang.code == $rootScope.selectedLangCode) {
                                            $rootScope.langDir = lang.rtl == true ? 'rtl' : 'ltr';
                                        }
                                    })
                                }

                                // if selectedlanguage is undefined or empty - set language from list.
                                if ($rootScope.selectedLangCode == undefined || $rootScope.selectedLangCode == '') {
                                    angular.forEach($rootScope.languageOptions, function (lang) {
                                        if (lang.is_default) {
                                            $rootScope.selectedLangCode = lang.code;
                                            $rootScope.langDir = lang.rtl == true ? 'rtl' : 'ltr';
                                        }
                                    });

                                    // if no default is found then
                                    if ($rootScope.selectedLangCode == undefined || $rootScope.selectedLangCode == '') {
                                        // todo issue here this is not updating the language code in login screen
                                        // var currentTranslationObj = commonService.localStorage.getKeyValue('translation', false);
                                        if ($rootScope.languageOptions.length > 0) {
                                            $rootScope.selectedLangCode = $rootScope.languageOptions[0].code
                                            $rootScope.langDir = $rootScope.languageOptions[0].rtl == true ? 'rtl' : 'ltr';
                                        }
                                    }
                                }

                                // get language string.
                                if ($rootScope.selectedLangCode) {
                                    translationsService.setTranslationStrings($rootScope.selectedLangCode);
                                }

                                deferred.resolve();

                            })

                            return deferred.promise;

                        }],
                        loadModule: ['$q', function ($q) {
                            if (publishDashboardId != undefined) {
                                var deferred = $q.defer();
                                // optional dependency - agGrid
                                if(publishDashboardDependency.indexOf('agGrid') > -1) {
                                    requirejs(['agGrid'], function (agGrid) {
                                        agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                        agGrid.initialiseAgGridWithAngular1(angular);
                                        // deferred.resolve('');
                                    });
                                }
                                // optional dependency - D3
                                if(publishDashboardDependency.indexOf('dfaD3') > -1) {
                                    requirejs(['d3'], function () {
                                        // deferred.resolve('');
                                    });
                                }
                                // optional dependency - dfaDotMatrix
                                if(publishDashboardDependency.indexOf('dfaDotMatrix') > -1) {
                                    requirejs(['d3', 'dfaDotMatrix'], function () {
                                        // deferred.resolve('');
                                    });
                                }
                                // required dependency
                                requirejs(['dashboardModule', 'previewModule'], function () {
                                    deferred.resolve('');
                                });
                                return deferred.promise;
                            } else {
                                return '';
                            }
                        }]
                    }
                })
                
                

                .state(registerState('notAuthorized'), {
                    url: 'NotAuthorized',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/core/views/notAuthorized.html'
                        }
                    }
                })

                .state(registerState('confirmPassword'), {
                    url: 'UserActivation/:key',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/userMgmt/views/confirmPassword.html',
                            controller: 'confirmPasswordCtrl'
                        }
                    },
                    resolve: {
                        loadController: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['userMgmt'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: false
                    }
                })

                .state(registerState('forgotPassword'), {
                    url: 'forgotPassword',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/userMgmt/views/forgotPassword.html',
                            controller: 'forgotPasswordCtrl'
                        }
                    },
                    resolve: {
                        loadController: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['userMgmt'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: false
                    }
                })

                // .state(registerState('register'), {
                //     url: 'register',
                //     views: {
                //         'header@': {
                //             templateUrl: 'js/app/components/core/views/header.html'
                //         },
                //         'content@': {
                //             templateUrl: 'js/app/components/core/views/register.html'
                //         }
                //     }
                // })                

                /** HOME STATE **/
                .state(registerState('home'), {
                    url: 'Home',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html?v=' + _REL_VERSION,
                            controller: 'homeCtrl'
                        }
                    },
                    resolve: {
                        loadController: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['homeModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: false
                    }
                })

                /* My Dashboard */
                .state(registerState('dashboardMgt', ['home']), {
                    url: '^/MyDashboards',
                    views: {
                        'moduleView@dfaBYD.home': {
                            templateUrl: 'js/app/components/dashboardMgt/views/index.html?v=' + _REL_VERSION,
                            controller: 'dashboardMgtCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['dashboardMgtModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })                

                /** Add Dashboard **/
                .state(registerState('add', ['home', 'dashboardMgt']), {
                    url: '/Add',
                    views: {
                        'moduleView@dfaBYD.home': {
                            templateUrl: 'js/app/components/dashboardMgt/views/addModify.html',
                            controller: 'addModifyDashboardCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['databaseModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /** Dashboard **/
                .state(registerState('dashboard'), {
                    url: '^/Dashboard/:dashboardId',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/dashboard/views/index.html?v=' + _REL_VERSION,
                            controller: 'dashboardCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['dashboardModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /** Dashboard - Settings **/
                .state(registerState('modify', ['dashboard']), {
                    url: '/Settings',
                    views: {
                        'moduleView@dfaBYD.dashboard': {
                            templateUrl: 'js/app/components/dashboardMgt/views/addModify.html',
                            controller: 'addModifyDashboardCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['dashboardMgtModule', 'databaseModule'], function () {

                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /** Dashboard - Design **/
                .state(registerState('design', ['dashboard']), {
                    url: '/Design',
                    views: {
                        'moduleView@dfaBYD.dashboard': {
                            templateUrl: 'js/app/components/design/views/index.html?v=' + _REL_VERSION,
                            controller: 'designCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['agGrid', 'd3'], function (agGrid) {
                                agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                agGrid.initialiseAgGridWithAngular1(angular);
                                requirejs(['databaseModule', 'designModule'], function () {
                                    deferred.resolve('');
                                })
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /** Dashboard - Preview **/
                .state(registerState('preview', ['dashboard']), {
                    url: '/Preview?showHeader&showFooter&section&areaId&timePeriod&sectionId&lang',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: 'js/app/components/preview/views/index.html?v=' + _REL_VERSION,
                            controller: 'previewCtrl'
                        },
                        'footer@': {}
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            
                            requirejs(['agGrid','d3'], function (agGrid) {
                                agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                agGrid.initialiseAgGridWithAngular1(angular);
                                requirejs(['previewModule'], function () {
                                    deferred.resolve('');
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })                

                // Dashboard preview with language code
                .state(registerState('previewWithLangCode', ['dashboard']), {
                    url: '/Preview/:langCode',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: 'js/app/components/preview/views/index.html?v' + _REL_VERSION,
                            controller: 'previewCtrl'
                        },
                        'footer@': {}
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['agGrid','d3'], function (agGrid) {
                                agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                agGrid.initialiseAgGridWithAngular1(angular);
                                requirejs(['previewModule'], function () {
                                    deferred.resolve('');
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /* My Gallery */
                .state(registerState('gallery', ['dashboard']), {
                    url: '^/Gallery?showHeader&showFooter&inheritBFrom&usedashboards&lang',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: 'js/app/components/gallery/views/index.html?v=' + _REL_VERSION,
                            controller: 'galleryCtrl'
                        },
                        'footer@': {}
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            
                            requirejs(['agGrid','d3'], function (agGrid) {
                                agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                agGrid.initialiseAgGridWithAngular1(angular);
                                requirejs(['galleryModule'], function () {
                                    deferred.resolve('');
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /* My Gallery */
                .state(registerState('profileHome', ['dashboard']), {
                    url: 'profileHome',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: 'js/app/components/profileHome/views/index.html?v=' + _REL_VERSION,
                            controller: 'profileHomeCtrl'
                        },
                        'footer@': {}
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            
                            requirejs(['agGrid','d3'], function (agGrid) {
                                agGrid.LicenseManager.setLicenseKey(agGridLscKey);
                                agGrid.initialiseAgGridWithAngular1(angular);
                                requirejs(['profileHomeModule'], function () {
                                    deferred.resolve('');
                                });
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /* About Us */
                .state(registerState('aboutUs'), {
                    url: '^/AboutUs',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.aboutUs': {
                            templateUrl: 'js/app/components/aboutUs/views/index.html',
                            controller: 'aboutUsCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['aboutUs', 'homeModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })    
                //preferences module

                .state(registerState('preferences'), {
                    url: '^/Preferences',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.preferences': {
                            templateUrl: 'js/app/components/preferences/views/index.html',
                            controller: 'preferencesCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['preferences', 'homeModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })

                 //headerFooter module

                 .state(registerState('headerFooter'), {
                    url: '^/HeaderandFooter',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.headerFooter': {
                            templateUrl: 'js/app/components/headerFooter/views/index.html?v=' + _REL_VERSION,
                            controller: 'headerFooterCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['headerFooterModule','homeModule','dashboard'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })

                /** Add Header Footer **/
                .state(registerState('add', ['headerFooter']), {
                    url: '/Add',
                    views: {
                        'moduleView@dfaBYD.headerFooter': {
                            templateUrl: 'js/app/components/headerFooter/views/addModify.html',
                            controller: 'addModifyHeaderFooterCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['headerFooterModule','dashboard'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                .state(registerState('modify', ['headerFooter']), {
                    url: '/Modify/:themeId',
                    views: {
                        'moduleView@dfaBYD.headerFooter': {
                            templateUrl: 'js/app/components/headerFooter/views/addModify.html',
                            controller: 'addModifyHeaderFooterCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: true,
                    }
                })

                /** Dashboard - Media Files **/
                .state(registerState('mediaFiles', ['dashboard']), {
                    url: '/MediaFiles',
                    views: {
                        'moduleView@dfaBYD.dashboard': {
                            templateUrl: 'js/app/components/mediaFiles/views/index.html?v=' + _REL_VERSION,
                            controller: 'mediaFilesCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: false,
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['mediaFilesModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })
                /** Dashboard - Media Files **/
                .state(registerState('medias'), {
                    url: '^/Medias',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.medias': {
                            templateUrl: 'js/app/components/medias/views/index.html?v=' + _REL_VERSION,
                            controller: 'mediasCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: false,
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['medias','homeModule','mediaFilesModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /** Dashboard - Publish **/
                .state(registerState('publish', ['dashboard']), {
                    url: '/Publish',
                    views: {
                        'moduleView@dfaBYD.dashboard': {
                            templateUrl: 'js/app/components/publish/views/index.html?v=' + _REL_VERSION,
                            controller: 'publishCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['publishModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /* Database */
                .state(registerState('database', ['home']), {
                    url: '^/Database',
                    views: {
                        'moduleView@dfaBYD.home': {
                            templateUrl: 'js/app/components/database/views/index.html',
                            controller: 'databaseCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['databaseModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                .state(registerState('add', ['home', 'database']), {
                    url: '/Add',
                    views: {
                        'moduleView@dfaBYD.home': {
                            templateUrl: 'js/app/components/database/views/addModify.html',
                            controller: 'addModifyDatabaseConnectionCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: true,
                    }
                })

                .state(registerState('modify', ['home', 'database']), {
                    url: '/Modify/:dbId',
                    views: {
                        'moduleView@dfaBYD.home': {
                            templateUrl: 'js/app/components/database/views/addModify.html',
                            controller: 'addModifyDatabaseConnectionCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: true,
                    }
                })

                /* Translations */
                .state(registerState('translations'), {
                    url: '^/Translations',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.translations': {
                            templateUrl: 'js/app/components/translations/views/index.html',
                            controller: 'translationsCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['homeModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })

                .state(registerState('add', ['translations']), {
                    url: '^/Translations/Add',
                    views: {
                        'moduleView@dfaBYD.translations': {
                            templateUrl: 'js/app/components/translations/views/addModify.html',
                            controller: 'addModifyCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: true
                    }
                })

                .state(registerState('modify', ['translations']), {
                    url: '^/Translations/Modify/:keyCode',
                    views: {
                        'moduleView@dfaBYD.translations': {
                            templateUrl: 'js/app/components/translations/views/addModify.html',
                            controller: 'addModifyCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: false
                    }
                })

                /* import/export translation*/
                .state(registerState('importExport', ['translations']), {
                    url: '/Import-Export',
                    views: {
                        'moduleView@dfaBYD.translations': {
                            templateUrl: 'js/app/components/translations/views/importExport.html',
                            controller: 'importExportCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: false
                    }
                })

                .state(registerState('explore', ['dashboard']), {
                    url: '/Explore/visId/:visId/areaId/:areaId/tp/:tp?langCode&selectedIUS&selectedIC&selectedIU&showViz&showQlt&showMeta',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: 'js/app/components/explore/views/index.html',
                            controller: 'exploreCtrl'
                        },
                        'footer@': {}
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['embedModule', 'exploreModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /** Dashboard - EMBED **/
                .state(registerState('embed', ['dashboard']), {
                    url: '^/Embed?dashboardId&visualizationId&areaId&tp&langCode&selectedIUS&selectedIC&selectedIU&areaData',
                    views: {
                        'header@': {},
                        'content@': {
                            templateUrl: 'js/app/components/embed/views/index.html',
                            controller: 'embedCtrl'
                        },
                        'footer@': {}
                    },
                    data: {
                        authenticationRequired: false
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['embedModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                /* Settings Management */
                .state(registerState('settingsMgmt'), {
                    url: '^/settingsMgmt',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.settingsMgmt': {
                            templateUrl: 'js/app/components/settingsMgmt/views/index.html',
                            controller: 'settingsMgmtCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['homeModule', 'settingsMgmtModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })

                
                /* User Management */
                .state(registerState('userMgmt'), {
                    url: '^/UserMgmt',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.userMgmt': {
                            templateUrl: 'js/app/components/userMgmt/views/index.html',
                            controller: 'userMgmtCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: true
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['homeModule', 'userMgmtModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    }
                })

                .state(registerState('modify', ['userMgmt']), {
                    url: '/Modify/:userId',
                    views: {
                        'moduleView@dfaBYD.userMgmt': {
                            templateUrl: 'js/app/components/userMgmt/views/addModify.html',
                            controller: 'userAddModifyCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: false
                    }
                })

                .state(registerState('add', ['userMgmt']), {
                    url: '/Add',
                    views: {
                        'moduleView@dfaBYD.userMgmt': {
                            templateUrl: 'js/app/components/userMgmt/views/addModify.html',
                            controller: 'userAddModifyCtrl'
                        }
                    },
                    data: {
                        authenticationRequired: true
                    }
                }) 
                
                /*Transaction Log*/
                .state(registerState('transactionLogs'), {
                    url: '^/TransactionLogs',
                    views: {
                        'header@': {
                            templateUrl: 'js/app/components/core/views/header.html'
                        },
                        'content@': {
                            templateUrl: 'js/app/components/home/views/index.html',
                            controller: 'homeCtrl'
                        },
                        'moduleView@dfaBYD.transactionLogs': {
                            templateUrl: 'js/app/components/transactionLogs/views/index.html',
                            controller: 'transactionLogsCtrl'
                        }
                    },
                    resolve: {
                        loadModule: ['$q', function ($q) {
                            var deferred = $q.defer();
                            requirejs(['homeModule', 'transactionLogsModule'], function () {
                                deferred.resolve('');
                            });
                            return deferred.promise;
                        }]
                    },
                    data: {
                        authenticationRequired: true
                    }
                })

            /*
                ** REGISTERING A STATE **
                newState - name of the new state (string)
                parentStates - parent states for the new state (array or a string)
            */
            function registerState(newState, parentStates) {
                var state = appConfig.appName;

                if (parentStates) {
                    if (!angular.isArray(parentStates)) {
                        parentStates = [parentStates];
                    }

                    state += '.' + parentStates.join('.');

                }

                if (newState) {
                    state += '.' + newState;
                }

                return state;
            }


        }
    ])
